import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Params } from '@angular/router'
import { Router } from '@angular/router'
import { EnrollmentGateway } from '../../gateways/enrollment-gateway'
import { EnrollmentViewModel } from '../../models/enrollment-view-model'
import { EappUpdateStatus } from '../../models/eapp-status-model'
import { PortalGlobals } from '../../../portalglobals'
@Component({
    selector: 'EAppEnrollmentMessage',
    templateUrl: 'e-app-enrollmentmessages.component.html'
})
export class EAppEnrollmentMessagesComponent implements OnInit {
    id: string
    appReject: boolean = false
    emailSent: boolean = false
    urlExpire: boolean = false
    appCorrection: boolean = false
    finalSubmit: boolean = false
    hasError: boolean
    ErrorMessages: any[]
    public insurance: string
    enrollmentViewModel: EnrollmentViewModel = new EnrollmentViewModel()
    eappUpdateStatusModel: EappUpdateStatus = {} as EappUpdateStatus
    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private _enrollmentGateway: EnrollmentGateway,
        private _global: PortalGlobals
    ) {}
    ngOnInit() {
        this.enrollmentViewModel = this._enrollmentGateway.getEnrollmentViewModel()

        var User = localStorage.getItem('UserSessionContext')
        this._global.currentUser = JSON.parse(User!)

        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()

        if (this._global === undefined || this._global.currentUser === undefined || this.enrollmentViewModel == undefined) {
            this.router.navigate(['/' + insCo + '/enrollment/e-app-info1'])
        } else {
            this.insurance = this._global.currentUser.insuranceCompanyName
            this.getParams()
            if (this.id === '1') {
                this.emailSent = true
                this.appReject = false
                this.urlExpire = false
                this.appCorrection = false
                this.finalSubmit = false
            } else {
                if (this.id === '2') {
                    this.appReject = true
                    this.emailSent = false
                    this.urlExpire = false
                    this.appCorrection = false
                    this.finalSubmit = false
                }
                if (this.id === '3') {
                    this.appReject = false
                    this.emailSent = false
                    this.urlExpire = true
                    this.appCorrection = false
                    this.finalSubmit = false
                }
                if (this.id === '4') {
                    this.appReject = false
                    this.emailSent = false
                    this.urlExpire = false
                    this.appCorrection = true
                    this.finalSubmit = false
                }
                if (this.id === '5') {
                    this.appReject = false
                    this.emailSent = false
                    this.urlExpire = false
                    this.appCorrection = false
                    this.finalSubmit = true
                }
            }
        }
    }

    getParams() {
        this.route.params.forEach((params: Params) => {
            this.id = this.route.snapshot.params['id']
        })
    }
    viewHistory() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this.router.navigate(['/' + insCo + '/enrollment/e-application/history'])
    }
}
